import React, { forwardRef, useImperativeHandle, useState } from "react";
import {
  Typography,
  Box,
  Tabs,
  Tab,
  Fade,
  RadioGroup,
  FormControlLabel,
  Radio,
  Collapse,
  Stack,
  Divider,
  Chip,
} from "@mui/material";
import BiometriaHematica from "./analisis/BiometriaHematica";
import PerfilLipidico from "./analisis/PerfilLipidico";
import QuimicaSanguinea from "./analisis/QuimicaSanguinea";
import PruebasGlucosa from "./analisis/PruebasGlucosa";
import ExamenGeneralOrina from "./analisis/ExamenGeneralOrina";
import PlieguesCutaneos from "./PlieguesCutaneos";
import Antropometria from "./Antropometria";
import IndicesCorporales from "./IndicesCorporales";
import { GlassPanel } from "./styledComponents";

const Paso4ComposicionFisica = forwardRef(
  (
    {
      formValues,
      formValuesBasic,
      onChange,
      formValuesGlucosa,
      onChangeGlucosa,
    },
    ref
  ) => {
    const [currentTab, setCurrentTab] = useState(0);
    const [submenuTab, setSubmenuTab] = useState(0);
    const [showAdditionalMenu, setShowAdditionalMenu] = useState(false);

    const handleTabChange = (event, newValue) => {
      setCurrentTab(newValue);
      setSubmenuTab(0);
    };

    const handleSubmenuTabChange = (event, newValue) => {
      setSubmenuTab(newValue);
    };

    const handleRadioChange = (event) => {
      setShowAdditionalMenu(event.target.value === "si");
    };

    useImperativeHandle(ref, () => ({
      validate: () => {
        return true;
      },
    }));

    return (
      <Box ref={ref} sx={{ py: { xs: 2, md: 3 } }}>
        <Fade in>
          <Stack spacing={3}>
            <GlassPanel>
              <Stack spacing={2}>
                <Box textAlign="center">
                  <Typography variant="overline" sx={{ letterSpacing: 3 }}>
                    Seguimiento físico
                  </Typography>
                  <Typography
                    variant="h5"
                    fontWeight={800}
                    color="primary.main"
                  >
                    Composición corporal
                  </Typography>
                  <Typography color="text.secondary" sx={{ mt: 1 }}>
                    Alterna entre perímetros y pliegues para capturar tus
                    últimas mediciones y mantener actualizado tu perfil clínico.
                  </Typography>
                </Box>
                <Stack direction="row" spacing={1} justifyContent="center">
                  {["Cinta métrica", "Auto registro"].map((tag) => (
                    <Chip
                      key={tag}
                      label={tag}
                      size="small"
                      variant="outlined"
                    />
                  ))}
                </Stack>
                <Divider />
                <Tabs
                  value={currentTab}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  indicatorColor="primary"
                  textColor="primary"
                >
                  <Tab label="Perímetros corporales" />
                  <Tab label="Pliegues cutáneos" />
                </Tabs>
                <Box>
                  {currentTab === 0 && (
                    <Antropometria
                      formValues={formValues}
                      onChange={onChange}
                      formValuesBasic={formValuesBasic}
                    />
                  )}
                  {currentTab === 1 && (
                    <PlieguesCutaneos
                      formValues={formValues}
                      onChange={onChange}
                    />
                  )}
                </Box>
              </Stack>
            </GlassPanel>

            <GlassPanel>
              <Stack spacing={2}>
                <Box>
                  <Typography variant="h6" fontWeight={700} gutterBottom>
                    ¿Tienes resultados de laboratorio o estudios
                    complementarios?
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Activa el menú adicional para capturar biometrías, perfiles
                    lipídicos y cualquier otro parámetro clínico relevante.
                  </Typography>
                </Box>
                <RadioGroup
                  row
                  value={showAdditionalMenu ? "si" : "no"}
                  onChange={handleRadioChange}
                >
                  <FormControlLabel value="si" control={<Radio />} label="Sí" />
                  <FormControlLabel value="no" control={<Radio />} label="No" />
                </RadioGroup>
                <Collapse in={showAdditionalMenu} timeout="auto" unmountOnExit>
                  <Stack spacing={2}>
                    <Tabs
                      value={submenuTab}
                      onChange={handleSubmenuTabChange}
                      variant="scrollable"
                      scrollButtons="auto"
                      indicatorColor="primary"
                      textColor="primary"
                    >
                      <Tab label="Índices corporales" />
                      <Tab label="Biometría hemática" />
                      <Tab label="Perfil lipídico" />
                      <Tab label="Química sanguínea" />
                      <Tab label="Pruebas de glucosa" />
                      <Tab label="Examen general de orina" />
                    </Tabs>
                    <Box>
                      {submenuTab === 0 && (
                        <IndicesCorporales
                          formValues={formValues}
                          onChange={onChange}
                        />
                      )}
                      {submenuTab === 1 && (
                        <BiometriaHematica
                          formValues={formValues}
                          onChange={onChange}
                        />
                      )}
                      {submenuTab === 2 && (
                        <PerfilLipidico
                          formValues={formValues}
                          onChange={onChange}
                        />
                      )}
                      {submenuTab === 3 && (
                        <QuimicaSanguinea
                          formValues={formValuesGlucosa}
                          onChange={onChangeGlucosa}
                        />
                      )}
                      {submenuTab === 4 && (
                        <PruebasGlucosa
                          formValues={formValues}
                          onChange={onChange}
                        />
                      )}
                      {submenuTab === 5 && (
                        <ExamenGeneralOrina
                          formValues={formValues}
                          onChange={onChange}
                        />
                      )}
                    </Box>
                  </Stack>
                </Collapse>
              </Stack>
            </GlassPanel>
          </Stack>
        </Fade>
      </Box>
    );
  }
);

export default Paso4ComposicionFisica;
